import Ratings from "../../components/profile/view/ratings";

export const dealAccordionTranslations = {
  en: {
    headerTitle: "My deals",
    headerSubtitle: "Manage and review your confirmed deals",
    loading: "Loading deals...",
    errorFetch: "Failed to fetch deals. Please try again later.",
    emptyState: "No confirmed deals found",
    dealMessage: "Deal Message",
    noMessage: "No message provided with this deal.",
    additionalDetails: "Additional Details",
    level: "Level",
    created: "Created",
    agreementFiles: "Agreement Files",
    noAgreementFiles: "No agreement files",
    download: "Download",
    attachmentFiles: "Agreement Details and Attachments",
    sportAndWeight: "{{sport}} • {{weightClass}}",
     invoice: "Invoice",
     result: "Result",
     ratings: "Ratings",
    notSpecified: "Not specified",
    yes: "Yes",
    no: "No",
    selectStatus: "Select status",
    fromDate: "Start Date",
    toDate: "End Date",
    pageSize: "Page size",
    resetFilters: "Reset filters",
    pageLabel: "Page {{page}}",
    previous: "Previous",
    next: "Next",
    loadingDetails: "Loading details...",
    noSummaryData: "No summary data",
    noFormData: "No form data",
    dealSummary: "Deal Summary",
    downloadReceipt: "Download Receipt",
    status: {
      proposed: "Proposed",
      accepted: "Accepted",
      confirmed: "Confirmed",
      waiting_for_result: "Waiting for result",
      result_updated: "Result updated",
      result_confirmed: "Result confirmed",
      fighter_rated: "Fighter rated",
      manager_rated: "Manager rated",
      finished: "Finished",
      cancelled: "Cancelled",
      rejected: "Rejected",
      dispute: "Dispute",
    },
       general: "General",
          activity: "Activity",
    progress: "Progress",
    selectResultToSeeAmount: "Select result to see amount",
    componentPayments: "Component Payments",
    rateThisDeal: "Rate this Deal",
    optionalFeedback: "Optional feedback (max 500 characters)",
    pleaseSelectRating: "Please select a rating",
    pleaseProvideRating: "Please provide a rating and confirm the result",
    youHaveRated: "You have already rated this deal",
    submitRatingOnly: "Submit Rating Only",
    submitRating: "Submit Rating",
    later: "Later",
    ratingSubmitted: "Rating submitted successfully!",
 
 dealDetails: "Deal Details",
    dealOverview: "Overview of the deal proposal",
    withdrawn: "Withdrawn",
    unknownUser: "Unknown User",
    noEmail: "No email provided",
    dealAccepter: "Deal accepter",
    dealInfo: "Deal Information",
    dealType: "Deal Type",
    price: "Price",
    eventDate: "Event Date",
    location: "Location",
    sport: "Sport",
    weightClass: "Weight Class",
    additionalInfo: "Additional Information",
    notes: "Notes",
    additionalMessage: "Additional Message",
    attachments: "Attachments",
    close: "Close",
    downloadAgreement: "Download Agreement",
    agreement: "Hoowlr Agreement",
    dealStatus: "Deal Status",
    invoiceSummary: "Invoice Summary",
    generateInvoice: "Generate Invoice",
    generating: "Generating...",
    noComponentPayments: "No component payments",
    Bonus: "Bonus",
    Pay: "Pay",
    cannotPayUntilAccepted: "Cannot pay until deal is accepted",
    downloadDocuments:"Download Deal Overview Summary",
 
 
    fightResult: "Fight Result",
    win: "Win",
    loss: "Loss",
    bonus: "Bonus",
    selectResult: "Select Result",
    noResultYet: "Waiting for Manager Result",
    submitResultOnly: "Submit Result",
    currentResult: "Current Result",
    earnings: "Earnings",
    managerConfirmed: "Manager Confirmed",
    submitDispute: "Submit Dispute",
    disputeSubtitle: "If you disagree with the result, you can submit a dispute.",
    resultSubmitted: "Result Submited",
    fillyourdespuit: "Fill your dispute form",
    yourFightResult: "Fight Result",
    description: "Description",
    explainWhatHappened: "Explain what happened...",
    resultUpdated: "Fight result updated!",
    confirmResult: "Yes, I Accepted",
    rejectresult: "No, I Decline",
    giveRating: "Give Ratings",
    resultConfirmed: "Result confirmed!",
    disputeSubmitted: "Dispute Submited",
    bothConfirmed: "Both parties confirmed the result",
    resultAlreadySet: "Result already submitted",
    howWasYourExperience: "How was your experience?",
    fightResultAndRating: "Fight Result",
    ratingsReceived: "Ratings Received",
    activityLog: "Activity Log",
 
    completeAllFields: "Please complete all required fields",
    resultAndRatingSubmitted: "Result and rating submitted successfully!",
    submissionFailed: "Submission failed. Please try again.",
    downloadFailed: "Download failed. Please try again.",
 
    noResult: "No Result",
    
  },
  de: {
    headerTitle: "Zusammenfassung der Geschäftsvereinbarung",
    headerSubtitle: "Verwalten und überprüfen Sie Ihre bestätigten Deals",
    loading: "Deals werden geladen...",
    errorFetch: "Fehler beim Abrufen der Deals. Bitte versuchen Sie es später erneut.",
    emptyState: "Keine bestätigten Deals gefunden",
    dealMessage: "Deal-Nachricht",
    noMessage: "Keine Nachricht zu diesem Deal angegeben.",
    additionalDetails: "Zusätzliche Details",
    level: "Level",
    created: "Erstellt",
    agreementFiles: "Vereinbarungsdateien",
    noAgreementFiles: "Keine Vereinbarungsdateien",
    download: "Herunterladen",
 
    sportAndWeight: "{{sport}} • {{weightClass}}",
    notSpecified: "Nicht angegeben",
    yes: "Ja",
    no: "Nein",
    selectStatus: "Status auswählen",
    fromDate: "Startdatum",
    toDate: "Enddatum",
    pageSize: "Seitengröße",
    resetFilters: "Filter zurücksetzen",
    pageLabel: "Seite {{page}}",
    previous: "Zurück",
    next: "Weiter",
    loadingDetails: "Details werden geladen...",
    noSummaryData: "Keine Zusammenfassungsdaten",
    noFormData: "Keine Formulardaten",
    dealSummary: "Deal-Zusammenfassung",
    downloadReceipt: "Beleg herunterladen",
    invoice: "Rechnung",
    result: "Ergebnis",
    ratings: "Bewertungen",
    general: "Allgemein",
    activity: "Aktivität",
    progress: "Fortschritt",
    componentPayments: "Komponentenzahlungen",
    dealAccepter: "Deal-Annehmer",
    downloadAgreement: "Vereinbarung herunterladen",
    selectResultToSeeAmount: "Ergebnis auswählen, um Betrag zu sehen",
     rateThisDeal: "Bewerten Sie diesen Deal",
    optionalFeedback: "Optionales Feedback (max. 500 Zeichen)",
    status: {
      proposed: "Vorgeschlagen",
      accepted: "Akzeptiert",
      confirmed: "Bestätigt",
      waiting_for_result: "Wartet auf Ergebnis",
      result_updated: "Ergebnis aktualisiert",
      result_confirmed: "Ergebnis bestätigt",
      fighter_rated: "Kämpfer bewertet",
      manager_rated: "Manager bewertet",
      finished: "Abgeschlossen",
      cancelled: "Storniert",
      rejected: "Abgelehnt",
      dispute: "Streitfall",
    },
    attachmentFiles:"Vertragsdetails und Anhänge",
  },
  hr: {
    headerTitle: "Sažetak ugovora",
    headerSubtitle: "Upravljajte i pregledajte svoje potvrđene dogovore",
    loading: "Učitavanje dogovora...",
    errorFetch: "Neuspješno dohvaćanje dogovora. Pokušajte ponovno kasnije.",
    emptyState: "Nema potvrđenih dogovora",
    dealMessage: "Poruka dogovora",
    noMessage: "Nema poruke uz ovaj dogovor.",
    additionalDetails: "Dodatni detalji",
    level: "Razina",
    created: "Kreirano",
    agreementFiles: "Datoteke ugovora",
    noAgreementFiles: "Nema datoteka ugovora",
    download: "Preuzmi",
 
    sportAndWeight: "{{sport}} • {{weightClass}}",
    notSpecified: "Nije navedeno",
    yes: "Da",
    no: "Ne",
    selectStatus: "Odaberite status",
    fromDate: "Datum početka",
    toDate: "Datum završetka",
    pageSize: "Veličina stranice",
    resetFilters: "Poništi filtre",
    pageLabel: "Stranica {{page}}",
    previous: "Prethodno",
    next: "Sljedeće",
    loadingDetails: "Učitavanje detalja...",
    noSummaryData: "Nema podataka za sažetak",
    noFormData: "Nema podataka obrasca",
    dealSummary: "Sažetak ugovora",
    downloadReceipt: "Preuzmi potvrdu",
    invoice: "Račun",
    result: "Rezultat",
    ratings: "Ocjene",
    general: "Općenito",
    activity: "Aktivnost",
    progress: "Napredak",
    componentPayments: "Plaćanja komponenti",
    dealAccepter: "Prihvatitelj dogovora",
    downloadAgreement: "Preuzmi ugovor",
    selectResultToSeeAmount: "Odaberite rezultat za prikaz iznosa",
     rateThisDeal: "Ocijenite ovaj dogovor",
    optionalFeedback: "Neobavezna povratna informacija (maksimalno 500 znakova)",
    status: {
      proposed: "Predloženo",
      accepted: "Prihvaćeno",
      confirmed: "Potvrđeno",
      waiting_for_result: "Čeka se rezultat",
      result_updated: "Rezultat ažuriran",
      result_confirmed: "Rezultat potvrđen",
      fighter_rated: "Borac ocijenjen",
      manager_rated: "Menadžer ocijenjen",
      finished: "Završeno",
      cancelled: "Otkazano",
      rejected: "Odbijeno",
      dispute: "Spor",
    },
    attachmentFiles:"Detalji ugovora i privitci",
  }
};
 
 
